import {
  OPEN_LOGIN_POPUP,
  CLOSE_LOGIN_POPUP,
  SET_USER,
  UNSET_USER,
  GET_INTERVIEWS,
} from "./types";

const initialState = {
  dialog: false,
  isAuth: false,
  interviews: []
  // user: {}
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INTERVIEWS:
      return {
        ...state,
        interviews: action.payload
      }
    case OPEN_LOGIN_POPUP:
      return {
        ...state,
        dialog: true,
      };
    case CLOSE_LOGIN_POPUP:
      return {
        ...state,
        dialog: false,
      };
    case SET_USER:
      localStorage.setItem("id", action.payload._id);
      localStorage.setItem("type", action.payload.type);
      localStorage.setItem("isAuth", true);
      return {
        ...state,
        isAuth: true,
        // user: action.payload
      };

    case UNSET_USER:
      localStorage.removeItem("id");
      localStorage.removeItem("isAuth");
      localStorage.removeItem("Detail");
      localStorage.removeItem("type");
      return {
        ...state,
        isAuth: false,
        // user: {}
      };
    default:
      return state;
  }
};

export default UserReducer;
